import { render, staticRenderFns } from "./techStackCard.vue?vue&type=template&id=9bcc9100&scoped=true&"
import script from "./techStackCard.vue?vue&type=script&lang=js&"
export * from "./techStackCard.vue?vue&type=script&lang=js&"
import style0 from "./techStackCard.vue?vue&type=style&index=0&id=9bcc9100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcc9100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bcc9100')) {
      api.createRecord('9bcc9100', component.options)
    } else {
      api.reload('9bcc9100', component.options)
    }
    module.hot.accept("./techStackCard.vue?vue&type=template&id=9bcc9100&scoped=true&", function () {
      api.rerender('9bcc9100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/crudApp/techStackCard.vue"
export default component.exports